var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountmanagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "71px",
    viewBox: "0 0 70.0 71.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561,0 L1561,1080 L0,1080 L0,0 L1561,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-51.6902382%",
    y: "-50.831072%",
    filterUnits: "userSpaceOnUse",
    width: "167.609529%",
    height: "166.485761%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-293.0 -191.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.0 207.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.7144241974028738 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14280729,4.07057654 C8.14280729,6.31877535 6.32005926,8.14115308 4.07140364,8.14115308 C1.82274802,8.14115308 0,6.31877535 0,4.07057654 C0,1.82237773 1.82274802,0 4.07140364,0 C6.32005926,0 8.14280729,1.82237773 8.14280729,4.07057654",
    stroke: "#2795E3",
    strokeWidth: 1.16325818,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.92863513080532 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14280729,4.07057654 C8.14280729,6.31877535 6.32005926,8.14115308 4.07140364,8.14115308 C1.82274802,8.14115308 0,6.31877535 0,4.07057654 C0,1.82237773 1.82274802,0 4.07140364,0 C6.32005926,0 8.14280729,1.82237773 8.14280729,4.07057654",
    stroke: "#2795E3",
    strokeWidth: 1.16325818,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.14284606420776 0.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14280729,4.07057654 C8.14280729,6.31877535 6.32005926,8.14115308 4.07140364,8.14115308 C1.82274802,8.14115308 0,6.31877535 0,4.07057654 C0,1.82237773 1.82274802,0 4.07140364,0 C6.32005926,0 8.14280729,1.82237773 8.14280729,4.07057654",
    stroke: "#2795E3",
    strokeWidth: 1.16325818,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 8.141153081510929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9859062,0 L28.442283,0 C27.0530425,0 25.8276664,0.709908549 25.1069891,1.7850835 C24.3863119,0.709908549 23.1609357,0 21.7716953,0 L16.2280721,0 C14.8388316,0 13.6134554,0.709908549 12.8927782,1.7850835 C12.172101,0.709908549 10.9467248,0 9.55748434,0 L4.01386114,0 C1.80033592,0 0,1.79997018 0,4.01304573 L0,8.14115308 L37.9997673,8.14115308 L37.9997673,4.01304573 C37.9997673,1.79997018 36.1994314,0 33.9859062,0 Z",
    stroke: "#2795E3",
    strokeWidth: 1.16325818,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.00023265163682495427 18.64711729622266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8568825,1.35685885 C29.8568825,7.35184891 24.9960143,12.2117296 18.9998061,12.2117296 C13.0035979,12.2117296 8.14272974,7.35184891 8.14272974,1.35685885 C8.14272974,0.896224652 8.18088461,0.445514911 8.23664345,0 L0,0 L0,4.07057654 C0,4.81987276 0.607686075,5.42743539 1.35713455,5.42743539 L3.23928629,5.42743539 C3.61881866,6.90873757 4.1995947,8.31351292 4.97354914,9.62400596 L3.64611645,10.9517893 C3.11598092,11.4818171 3.11598092,12.3404374 3.64611645,12.8704652 L7.48424806,16.7078171 C8.01438359,17.2378449 8.87317833,17.2378449 9.40331386,16.7078171 L10.731367,15.3806541 C12.0418161,16.1545288 13.4468769,16.7347992 14.92848,17.1145646 L14.92848,18.9960239 C14.92848,19.7453201 15.5361661,20.3528827 16.2856146,20.3528827 L21.7141528,20.3528827 C22.4636012,20.3528827 23.0712873,19.7453201 23.0712873,18.9960239 L23.0712873,17.1142545 C24.5528905,16.7347992 25.9579513,16.1541412 27.2687106,15.3803439 L28.5967637,16.707507 C29.1268992,17.2375348 29.985694,17.2375348 30.5158295,16.707507 L34.3539611,12.8701551 C34.8840966,12.3401272 34.8840966,11.481507 34.3539611,10.9514791 L33.0265284,9.62369583 C33.8004829,8.31351292 34.3809487,6.90873757 34.7607913,5.42743539 L36.6426328,5.42743539 C37.3920813,5.42743539 37.9997673,4.81987276 37.9997673,4.07057654 L37.9997673,0 L29.7631239,0 C29.8188827,0.445514911 29.8570376,0.896224652 29.8570376,1.35685885 L29.8568825,1.35685885 Z",
    stroke: "#2795E3",
    strokeWidth: 1.16325818,
    fill: "none",
    strokeMiterlimit: 10
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountmanagement);
export default __webpack_public_path__ + "static/media/accountmanagement.148a51932353cc89bd4e6b8b8910c81e.svg";
export { ForwardRef as ReactComponent };